/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PreOpsAnswerList
 */
export interface PreOpsAnswerList {
    /**
     * 
     * @type {boolean}
     * @memberof PreOpsAnswerList
     */
    userFullName: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PreOpsAnswerList
     */
    vehicleSerialNumber: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PreOpsAnswerList
     */
    departmentLabel: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PreOpsAnswerList
     */
    preOpsChecklistLabel: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PreOpsAnswerList
     */
    preOpsQuestionBody: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PreOpsAnswerList
     */
    preOpsAnswerChoice: boolean;
}

/**
 * Check if a given object implements the PreOpsAnswerList interface.
 */
export function instanceOfPreOpsAnswerList(value: object): value is PreOpsAnswerList {
    if (!('userFullName' in value) || value['userFullName'] === undefined) return false;
    if (!('vehicleSerialNumber' in value) || value['vehicleSerialNumber'] === undefined) return false;
    if (!('departmentLabel' in value) || value['departmentLabel'] === undefined) return false;
    if (!('preOpsChecklistLabel' in value) || value['preOpsChecklistLabel'] === undefined) return false;
    if (!('preOpsQuestionBody' in value) || value['preOpsQuestionBody'] === undefined) return false;
    if (!('preOpsAnswerChoice' in value) || value['preOpsAnswerChoice'] === undefined) return false;
    return true;
}

export function PreOpsAnswerListFromJSON(json: any): PreOpsAnswerList {
    return PreOpsAnswerListFromJSONTyped(json, false);
}

export function PreOpsAnswerListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreOpsAnswerList {
    if (json == null) {
        return json;
    }
    return {
        
        'userFullName': json['userFullName'],
        'vehicleSerialNumber': json['vehicleSerialNumber'],
        'departmentLabel': json['departmentLabel'],
        'preOpsChecklistLabel': json['preOpsChecklistLabel'],
        'preOpsQuestionBody': json['preOpsQuestionBody'],
        'preOpsAnswerChoice': json['preOpsAnswerChoice'],
    };
}

export function PreOpsAnswerListToJSON(json: any): PreOpsAnswerList {
    return PreOpsAnswerListToJSONTyped(json, false);
}

export function PreOpsAnswerListToJSONTyped(value?: PreOpsAnswerList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userFullName': value['userFullName'],
        'vehicleSerialNumber': value['vehicleSerialNumber'],
        'departmentLabel': value['departmentLabel'],
        'preOpsChecklistLabel': value['preOpsChecklistLabel'],
        'preOpsQuestionBody': value['preOpsQuestionBody'],
        'preOpsAnswerChoice': value['preOpsAnswerChoice'],
    };
}

